exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-stepper[data-v-c0e81f1a]{border:0!important;-webkit-box-shadow:none!important;box-shadow:none!important}.v-stepper[data-v-c0e81f1a],.v-stepper__content[data-v-c0e81f1a]{padding:0!important}", ""]);

// exports
